import { Component, computed, effect, inject, input, model, output, signal, untracked } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { FORM_FIELD, ValidationError } from '@angular/forms/signals';

import { of } from 'rxjs';

import { AssetService } from '../../../services/asset';
import { SpinnerLoaderDirective } from '../../directives/spinner-loader.directive';

@Component({
  selector: 'fs-vendor-select',
  imports: [SpinnerLoaderDirective],
  templateUrl: './vendor-select.html',
  styleUrl: './vendor-select.scss'
})
export class VendorSelect {
  private readonly assetService = inject(AssetService);
  protected readonly formField = inject(FORM_FIELD, { optional: true });
  
  readonly value = model<string>('');
  readonly touch = output<void>();
  readonly disabled = input<boolean>(false);
  readonly assetTypeId = input<string>('');
  readonly errors = computed(() => this.formField?.errors() ?? []);
  readonly isInvalid = computed(() => !!this.formField?.state().invalid() && !!this.formField?.state().touched());

  constructor() {
    effect(() => {
      this.assetTypeId();
      
      untracked(() => {
        this.value.set('');
      })
    });
  }

  readonly vendorsResource = rxResource({
    params: () => ({
      assetTypeId: this.assetTypeId()
    }),
    stream: ({ params }) => {
      if (!this.disabled()) return this.assetService.getDeviceVendors(params);
      return of([]);
    }
  });

  onBlur() {
    this.touch.emit();
  }

  onSelectionChange(event: Event) {
    const target = event.target as HTMLSelectElement;
    this.value.set(target.value);
    this.touch.emit();
  }
}
